import { render } from "./post-smtp-banners.vue?vue&type=template&id=5de74806&scoped=true"
import script from "./post-smtp-banners.vue?vue&type=script&lang=js"
export * from "./post-smtp-banners.vue?vue&type=script&lang=js"

import "./post-smtp-banners.vue?vue&type=style&index=0&id=5de74806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de74806"],['__file',"src/components/post-smtp-banners.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5de74806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5de74806', __exports__)) {
    api.reload('5de74806', __exports__)
  }
  
  module.hot.accept("./post-smtp-banners.vue?vue&type=template&id=5de74806&scoped=true", () => {
    api.rerender('5de74806', render)
  })

}


export default __exports__